/**
 * 应用 CGI 调用接口封装
 */
import FriendRecommend from "@tencent/midas-cgi/cgis/friend_recommend"
import { getCgiObj } from "./cgi"

const defaultConfig = {
  hideLoading: false
}

class FriendRecommendApi {
  /**
   * 构造函数
   * @param options 初始化cgiObj所需参数
   */
  constructor(options) {
    let { pf, sandbox, sessionObj, offerId } = options

    this.cgiObj = getCgiObj({
      pf,
      sandbox,
      sessionObj,
      offerId
    })

    this.cgiNames = {
      FriendRecommend: new FriendRecommend(defaultConfig)
    }
  }

  /**
   * 查某个道具的推荐好友
   * @param subject_id
   * @returns promise
   */
  queryPropsRecommFriend({ subject_id, request_num, cur_num }) {
    let params = {
      action: "get_recommend_friends",
      subject_id,
      request_num,
      cur_num
    }

    return this.cgiObj.request(this.cgiNames["FriendRecommend"], params)
  }

  /**
   * 推荐一个物品/删除推荐/隐藏推荐/从隐藏恢复
   * @param subject_id
   * @param behavior
   * @param zoneParams
   * @returns promise
   */
  recommPropsAction({ subject_id, behavior, sentence, deleteSentence = false, zoneParams }) {
    let params = {
      action: "recommend",
      subject_id,
      behavior
    }

    if (sentence) {
      params.sentence = encodeURIComponent(sentence)
    }

    if (deleteSentence) {
      params.sentence = ""
    }

    if (zoneParams) {
      params = {
        ...params,
        ...zoneParams
      }
    }

    if (params?.sentence?.length >= 512) {
      return Promise.resolve({
        ret: -1,
        msg: "标签太多啦，精选一些吧~"
      })
    }

    return this.cgiObj.request(this.cgiNames["FriendRecommend"], params)
  }

  /**
   * 获取当前用户某个物品推荐状态
   * @param subject_id
   * @returns promise
   */
  queryUserReocmmStatus({ subject_id }) {
    let params = {
      action: "get_recommend_status",
      subject_id
    }

    return this.cgiObj.request(this.cgiNames["FriendRecommend"], params)
  }

  /**
   * 获得用户评分列表
   * @param subject_id
   * @returns {*}
   */
  queryUserRecommStatusList({ subject_id }) {
    let params = {
      action: "get_recommend_status_list",
      subject_id
    }

    return this.cgiObj.request(this.cgiNames["FriendRecommend"], params)
  }
}

export { FriendRecommendApi }
